module.exports = __webpack_public_path__ + "img/search.6796a58b.svg";